import * as React from 'react';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function RadioButtons({ name, checked, onChange, value, disabled = false }) {
    return (
        <Radio
            name={name}
            checked={checked}
            onChange={onChange}
            value={value}
            disabled={disabled}
            sx={{
                padding: '2px 0px 0px 0px',
                color: '#f8a21e',
                '& .MuiSvgIcon-root': {
                    fill: disabled ? 'gray' : '#f8a21e'
                }
            }}
        />
    );
}

export function RadioWithLabel({
    name,
    checked,
    onChange,
    value,
    disabled = false,
    label = 'Radio Label'
}) {
    return (
        <FormControlLabel
            value={value}
            label={label}
            control={
                <Radio
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    value={value}
                    disabled={disabled}
                    sx={{
                        // padding: '2px 0px 0px 0px',
                        color: '#f8a21e',
                        '& .MuiSvgIcon-root': {
                            fill: disabled ? 'gray' : '#f8a21e'
                        }
                    }}
                />
            }
            sx={{
                cursor: disabled ? 'not-allowed !important' : 'default',
                '& .MuiFormControlLabel-label': {
                    fontSize: '1.25rem !important',
                    color: disabled ? 'gray !important' : '#f5f5f5',
                    fontFamily: 'Nunito, sans-serif',
                    fontWeight: '600'
                }
            }}
        />
    );
}

{
    /* <Radio
        checked={selectedValue === 'a'}
        onChange={handleChange}
        value="a"
        name="radio-buttons"
        inputProps={{ 'aria-label': 'A' }}
      />
      <Radio
        checked={selectedValue === 'b'}
        onChange={handleChange}
        value="b"
        name="radio-buttons"
        inputProps={{ 'aria-label': 'B' }}
      /> */
}
